import { utils as sharedUtils } from '@bond/utils'
import { clearAllResolvedErrors } from './clearAllResolvedErrors'
import { clickOutside } from './clickOutside'
import { generateFieldConstraints } from './generateFieldConstraints'
import { getRandomString } from './getRandomString'
import { modifyScheduleFormData } from './modifyScheduleFormData'

export const utils = {
  ...sharedUtils,
  clearAllResolvedErrors,
  clickOutside,
  generateFieldConstraints,
  getRandomString,
  modifyScheduleFormData,
}
